/**
 * 상태 데이터 관련 Mixin
 * 설비 상태 조회 및 관련 데이터 관리
 */
import backEndApi from "@src/api/backEndApi";
import moment from "moment";

export default {
    methods: {
        async getSystemType(data) {
            if (data) {
                try {
                    let find = this.$store.state.systemTypeList.find((item) => item.sysType == data.sysType);
                    this.systemName = find.sysTypeName;
                } catch (e) {
                    console.error(e);
                }
            }
        },
        async getEquipType(data) {
            if (data) {
                try {
                    let find = this.$store.state.equipTypeList.find((item) => item.equipType == data.equipType);
                    if (find) this.equipName = find.equipTypeName;
                } catch (e) {
                    console.error(e);
                }
            }
        },
        async getEquipTypeDetail(data) {
            if (data.equipType) {
                try {
                    let result = await backEndApi.equipTypes.getEquipType(data.equipType, "Y");
                    if (result.status == 200) {
                        this.equipTypeDetail = result.data;
                        // props들의 prop code 들을 dispOrder순서대로 sorting한다
                        this.sortedProps(result.data);
                        this.ctrlMode = this.equipTypeDetail.ctrlModes.length > 0 ? true : false;
                    } else {
                        this.alertWarning(
                            `${result.data.message}`,
                            "",
                            `${typeof result.data.detail == "string" ? result.data.detail : ""}`
                        );
                    }
                } catch (e) {
                    console.error(e);
                }
            }
        },
        async getSysNode(nodeIdx) {
            try {
                let result = await backEndApi.sysNode.getSysNode(nodeIdx);
                if (result.status == 200) {
                    this.nodeInfo = result.data;
                } else {
                    this.alertWarning(
                        `${result.data.message}`,
                        "",
                        `${typeof result.data.detail == "string" ? result.data.detail : ""}`
                    );
                }
            } catch (e) {
                console.error(e);
            }
        },
        async getRelatedPointStatus(data) {
            try {
                let result = await backEndApi.sysNode.getRelatedPointStatus(data.sysNodeIdx);
                if (result.status == 200) {
                    //TableList Component에서 Date Formatter 오류가 발생하여 임시 조치
                    result.data.forEach((item) => (item.updDt = moment(item.updDt).format("YYYY-MM-DD HH:mm:ss")));
                    this.rltdLiveStatus = result.data;
                } else {
                    this.alertWarning(
                        `${result.data.message}`,
                        "",
                        `${typeof result.data.detail == "string" ? result.data.detail : ""}`
                    );
                }
            } catch (e) {
                console.error(e);
            }
        },
        async getphscPointUsage() {
            this.phscPointUsageMap = new Map();
            this.phscPointUsageArr = await backEndApi.commonCode.getCommonCode("phscPointUsage");

            this.phscPointUsageArr.data.codeItems.forEach((item) => {
                this.phscPointUsageMap.set(item.codeItem, item.codeName);
            });
        },
    },
};
